
import { Vue, Prop, Component } from 'vue-property-decorator'

import 'whatwg-fetch'

import { Secret } from '../models/Secret'

import ResizeObserver from 'resize-observer-polyfill'

@Component({})
export default class ShowSecret extends Vue {
  @Prop()
  private url!: string;

  private mounted () {
    if (!this.$store.state.secret.secret) {
      this.getSecret()
    }

    const secret: HTMLElement = document.getElementById('private-message') as HTMLElement
    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        if (entry.target === secret) {
          /** Calculate the new width for the view and check if it is greater than the minimum width */
          const width = (entry.target as HTMLElement).offsetWidth + 110
          if (width >= 530 && width < window.innerWidth - 100) {
            this.$store.commit('setContentWidth', width)
          }
        }
      }
    })

    /** Observe the textarea */
    resizeObserver.observe(secret)
  }

  private async getSecret () {
    try {
      const secret = await Secret.get(this.url)

      this.$store.dispatch('setSecret', secret)
    } catch (e) {
      this.$router.push({ name: 'Error' })
    }
  }

  private async deleteSecret () {
    try {
      await Secret.delete(this.url)
    } catch (e) {
      // Secret already deleted
    }
    this.$router.push({ name: 'secretDeleted' })
  }

  /** Shows a toast that says that the text has been copied to the clipboard */
  private showCopiedToast () {
    this.$anxToast.show(String(this.$t('message.c_copied_to_clipboard')), { verticalAlign: 'bottom', horizontalAlign: 'center' })
  }
}

